import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import "./Layout.css";
import ProfileImage1 from "../../../assets/images/profile/Ellipse4.png";

const Layout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const contentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    contentRef.current?.focus();
    setSidebarOpen(false);
  }, [location]);

  // Get the admin status from Redux:
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  // Get the userProfile from Redux:
  const userProfile = useSelector((state) => state.auth.userProfile);
  // userType based on isAdmin
  const userType = isAdmin ? "admin" : "mdt";

  // dummy user for the testing
  const user = userProfile || {
    name: "Lee Kuvalis",
    profile_picture: ProfileImage1,
    email: "samplemail@mail.com",
    mdt_role: "Psychologist",
  };

  return (
    <div className="layout">
      <Sidebar
        userType={userType}
        className={sidebarOpen ? "open" : ""}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="content-area">
        <Header
          title={title}
          user={user}
          onBurgerClick={() => setSidebarOpen((o) => !o)}
        />
        <div ref={contentRef} tabIndex="-1" className="dashboard-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
